<mat-form-field class="w-100-p">
    <mat-label>{{ 'PAGE.CERTIFICATIONS.LABEL.PROVIDER' | translate }}</mat-label>
    <input
        matInput
        [formControl]="providerInputCtrl"
        [matAutocomplete]="providerAuto"
        [required]="!!providerControl?.validator"
        autocomplete="off"
    />
    <mat-autocomplete #providerAuto="matAutocomplete" [displayWith]="displayProviderName" (optionSelected)="onProviderOptionSelected($event)">
        <mat-option *ngFor="let provider of providers" [value]="provider">
            {{ provider.providerName }}
        </mat-option>
        <mat-option *ngIf="showCreateProvider" [value]="createProviderOption" class="certificate-taxonomy-create-option">
            <span class="certificate-taxonomy-create-label inline-flex items-center">
                <mat-icon class="icon-18 mr-2">add</mat-icon>
                <span>{{ 'PAGE.CERTIFICATIONS.BUTTON.CREATE_NAME' | translate: { name: createProviderName } }}</span>
            </span>
        </mat-option>
    </mat-autocomplete>
</mat-form-field>

<mat-form-field class="w-100-p">
    <mat-label>{{ 'PAGE.CERTIFICATIONS.LABEL.CERTIFICATION' | translate }}</mat-label>
    <input
        matInput
        [formControl]="certificationInputCtrl"
        [matAutocomplete]="certificationAuto"
        [required]="!!certificationControl?.validator"
        autocomplete="off"
    />
    <mat-autocomplete #certificationAuto="matAutocomplete" [displayWith]="displayCertificationName" (optionSelected)="onCertificationOptionSelected($event)">
        <mat-option *ngFor="let certification of certifications" [value]="certification">
            {{ certification.certificationName }}
        </mat-option>
        <mat-option *ngIf="showCreateCertification" [value]="createCertificationOption" class="certificate-taxonomy-create-option">
            <span class="certificate-taxonomy-create-label inline-flex items-center">
                <mat-icon class="icon-18 mr-2">add</mat-icon>
                <span>{{ 'PAGE.CERTIFICATIONS.BUTTON.CREATE_NAME' | translate: { name: createCertificationName } }}</span>
            </span>
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
